// import { css } from 'styled-components';

export function inputReset() {
  return `
    border:none;
    background-image:none;
    background-color:transparent;
    box-shadow: none;
  `;
}
